import { useLocalStorage } from '@client/hooks/use-local-storage';
import { colors } from '@client/new/components/colors';
import { useUser } from '@client/new/hooks/use-user';
import { faXmark } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Alert, IconButton } from '@mui/material';

type StripePaymentMethodAlertProps = {
  closeable?: boolean;
};

export const StripePaymentMethodAlert = (p: StripePaymentMethodAlertProps) => {
  const [closed, setClosed] = useLocalStorage(
    'stripePaymentMethodAlertClosed',
    false,
  );

  const { influencer } = useUser();

  const show = influencer?.stripeUserId && influencer.paymentMethod === null;

  return show && (!p.closeable || !closed) ? (
    <Alert
      severity="error"
      sx={{
        background: colors.errorAlertBg,
        '& .MuiAlert-message': {
          width: '100%',
        },
      }}
    >
      <div className="flex flex-1 justify-between">
        <span>
          Your Stripe account is not configured as a valid payment method.
        </span>
        <div className="flex gap-2 items-center">
          <a
            href="mailto:creatorsupport@playbookapp.io"
            className="text-inherit underline"
          >
            Contact support
          </a>
          {p.closeable && (
            <IconButton size="large" onClick={() => setClosed(true)}>
              <FontAwesomeIcon icon={faXmark} className="text-xs text-gray-1" />
            </IconButton>
          )}
        </div>
      </div>
    </Alert>
  ) : null;
};
